// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"41e471aa","877":"07f63cff"}[chunkId] + ".chunk.js";
};